<tlk-modal-header>
	<button tlkButton variant="ghost" size="l" right-icon (click)="modalWindowRef.close()">
		<tlk-close-empty-icon class="tlk-icon_size_l" />
	</button>
</tlk-modal-header>

<tlk-modal-content>
	<div [ngSwitch]="data.shouldNotifyCompanyByEmail$ | async" class="rx-awareness-mini-popup-content">
		<span class="use-email-text" *ngSwitchCase="true">{{ 'Awareness.BannerPopupEmail' | translate }}</span>
		<ng-container *ngSwitchCase="false">
			<span>{{ 'Awareness.BannerPopupQR' | translate }}</span>
			<rx-awareness-qr-code class="rx-awareness-mini-popup-qr" width="256" height="256"></rx-awareness-qr-code>
			<div *ngIf="data.showLearningCenterPart$ | async">
				<span>{{ 'Awareness.PopupLearningCenterOrPart' | translate | titlecase }} {{ 'Awareness.PopupLearningCenterVisitPart' | translate | lowercase }} </span>
				<a cdkFocusInitial [href]="data.linkToTheLearningCenter$ | async" target="_blank" rel="noopener noreferrer">{{ 'Awareness.PopupLearningCenter' | translate | lowercase }}</a>
			</div>
		</ng-container>
	</div>
</tlk-modal-content>
